import { hydrate } from '@conekta/cronos/client';
import { Main } from 'app/pages/frames/pages/component-tokenizer/views/Main';

hydrate(() => <Main />);
